import React, { useState } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Input, Modal, Tooltip } from 'antd';
import { uploadDocument } from '@gtintel/platform-api';
import ModalIcon from '../../../atoms/Icons/ModalIcon';
import { CustomAlert } from '../../../atoms/Modal/Alert/styles';
import ModalForm from '../../../atoms/Modal/Form';
import ModalIconSection from '../../../atoms/Modal/IconSection';
import ModalLabel from '../../../atoms/Modal/Label';
import ModalTitle from '../../../atoms/Modal/Title';
import { AddButton } from './styles';
export default function AddFolder({
  isUploadingDisabled,
  projectId,
  path,
  refreshFileList
}) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [folderName, setFolderName] = useState('');
  const [msg, setMsg] = useState('');
  const [type, setType] = useState('');
  const [loading, setLoading] = useState(false);
  const showModal = () => {
    setIsModalVisible(true);
  };
  const closeModal = () => {
    setIsModalVisible(false);
    setMsg('');
    setType('');
  };
  const setError = errMsg => {
    setMsg(errMsg);
    setType('error');
  };
  const handleOk = () => {
    const finalPath = path + folderName.trim().replace(/[~`!@#$%^&*()+={}[\];:'"<>.,/\\?_]/g, '') + '/';
    if (folderName.trim().length === 0) {
      setError('Please fill out the folder name!');
      return;
    }
    setLoading(true);
    uploadDocument({
      project_id: projectId,
      path: finalPath,
      file: null
    }).then(response => {
      if (response.id) {
        setMsg('Your folder was created successfully');
        setType('success');
        refreshFileList();
        setTimeout(() => {
          setFolderName('');
          setLoading(false);
          closeModal();
        }, 2000);
      } else {
        setError(response.message);
        setLoading(false);
      }
    }).catch(error => {
      if (error.data) {
        setError(error.data.message);
        setLoading(false);
      }
    });
  };
  return <>
      <AddButton data-public type="default" data-testid="doc-add-folder-button" disabled={isUploadingDisabled} onClick={showModal} size="small">
        Add Folder
      </AddButton>
      <Modal visible={isModalVisible} closable keyboard onOk={handleOk} onCancel={closeModal} okButtonProps={{
      disabled: loading
    }} cancelButtonProps={{
      disabled: loading
    }} okText="Confirm" data-testid="doc-add-folder-modal">
        <ModalIconSection>
          <ModalIcon type="add" />
          <ModalTitle>Add new folder</ModalTitle>
          The folder will be added to{' '}
          {path ? <>
              this path: <strong>{path}</strong>
            </> : <>
              the <strong>root folder</strong>
            </>}
        </ModalIconSection>

        {type && <CustomAlert message={msg} type={type} showIcon closable data-testid="doc-add-folder-msg" />}

        <ModalForm>
          <ModalLabel>
            Folder Name{' '}
            <Tooltip color="red" title="Special characters will be removed">
              <InfoCircleOutlined />
            </Tooltip>
          </ModalLabel>
          <Input value={folderName} data-testid="doc-add-folder-input" onChange={e => setFolderName(e.target.value)} placeholder="Folder name with no special characters" />
        </ModalForm>
      </Modal>
    </>;
}